import { render, staticRenderFns } from "./AssignedTime.vue?vue&type=template&id=2ffdcd3c&"
import script from "./AssignedTime.vue?vue&type=script&lang=ts&"
export * from "./AssignedTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports